import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {FITH2Helper} from "../utils/FITH2Helper";
import {Sprite} from "pixi.js";
import Spine = PIXI.spine.Spine;
import {FireInTheHole2} from "../FireInTheHole2";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {gsap} from "gsap";
import {FITH2GameConfig} from "../configs/FITH2GameConfig";

export class FITH2Background extends PIXI.Container implements StageLayer {

    //landscape, portrait_normal, portrait_fs
    private _spines: PIXI.spine.Spine[];
    private _mainGameBG: PIXI.Container;
    private _bonusGameBG: PIXI.Container;
    private _fsAnimation: Spine;
    private _gameNameAndWays: PIXI.Container;
    private _topGradient: PIXI.Sprite;
    private _fsBGEffect: PIXI.Sprite;
    private _dimmer: PIXI.Sprite;
    constructor() {
        super();
        this.name = "Background";
        this._spines = [];
        this.init();
    }

    private init() {
        const mainBG: Sprite = FITH2Helper.createSprite("introBg", 360, 360);
        mainBG.anchor.set(0.5, 0.5);
        this.addChild(mainBG);
        this._topGradient = FITH2Helper.createSprite("dark_gradient", 360, 0);
        this._topGradient.anchor.set(0.5, 0);
        this._topGradient.alpha = 0.3;
        this._topGradient.blendMode = PIXI.BLEND_MODES.MULTIPLY;

        this._fsBGEffect = new PIXI.Sprite(PIXI.Texture.WHITE);
        this._fsBGEffect.anchor.set(0.5, 0.5);
        this._fsBGEffect.position.set(360, 360);
        this._fsBGEffect.tint = 0x390A06;
        this._fsBGEffect.name = "fsBGEffect";
        this._fsBGEffect.alpha = 0.5;
        this._fsBGEffect.visible = false;

        this.addChild(this._fsBGEffect, this._topGradient);
        this._mainGameBG = this.addNormalBGAnimation();
        this._bonusGameBG = this.addFSBGAnimation();
        this.creatDimmer();
        this.onResize();
    }

    private creatDimmer(): void {
        this._dimmer = new PIXI.Sprite(PIXI.Texture.WHITE);
        this._dimmer.name = "dimmer";
        this._dimmer.position.set(360, 360);
        this._dimmer.anchor.set(0.5, 0.5);
        this._dimmer.tint = 0x000000;
        this._dimmer.alpha = 0.5;
        this._dimmer.visible = false;
    }

    private addNormalBGAnimation(): PIXI.Container {
        const normalBgContainer: PIXI.Container = new PIXI.Container();
        normalBgContainer.name = "mainGameBGContainer";
        return normalBgContainer;
    }

    private addFSBGAnimation(): PIXI.Container {
        const fsBgContainer: PIXI.Container = new PIXI.Container();
        fsBgContainer.name = "bonusGameBGContainer";
        this._fsAnimation = new PIXI.spine.Spine(FireInTheHole2.assetLoader.getSpineAsset("FS_background"));
        this._fsAnimation.position.set(360, 360);
        fsBgContainer.addChild(this._fsAnimation);
        return fsBgContainer;
    }

    public setMode(mode: string): void {
        if (FITH2Helper.isNormal(mode)) {
            this._bonusGameBG.visible = false;
            this._fsBGEffect.visible = false;
            this.addChild(this._mainGameBG);
        } else {
            this._bonusGameBG.visible = true;
            this._fsBGEffect.visible = true;
            this.addChild(this._bonusGameBG);
        }
    }

    public addDimmer(): gsap.core.Timeline {
        return gsap.timeline().add(() => {
            this.addChild(this._dimmer);
            this._dimmer.alpha = 0;
            this._dimmer.visible = true;
        }).add(gsap.to(this._dimmer, 0.2, {alpha: 0.7}));
    }

    public removeDimmer(): gsap.core.Timeline {
        return gsap.timeline().add(gsap.to(this._dimmer, 0.2, {alpha: 0})).add(() => {
            this._dimmer.visible = false;
        });
    }

    public onResize() {
        const isLandscape: boolean = NolimitApplication.isLandscape;
        if (this._bonusGameBG.visible && this._fsAnimation) {
            this._fsAnimation.state.setAnimation(0, isLandscape ? "landscape" : "portrait", true);
        }
        //this._fsBGEffect.width = NolimitApplication.screenBounds.width;
        //this._fsBGEffect.height = NolimitApplication.screenBounds.height;
        this._dimmer.width = NolimitApplication.screenBounds.width;
        this._dimmer.height = NolimitApplication.screenBounds.height;
        this._topGradient.width = NolimitApplication.screenBounds.width;
        this._topGradient.position.y = NolimitApplication.screenBounds.top;
    }


}